import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginBackground from './components/LoginBackground';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SubscriptionStatus from './components/SubscriptionStatus';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const authToken = localStorage.getItem('authToken');
    const userData = localStorage.getItem('userData');
    
    if (authToken && userData) {
      try {
        const user = JSON.parse(userData);
        // Check if subscription is still active
        if (user.subscriptionStatus === 'active') {
          navigate('/dashboard');
          return;
        }
      } catch (error) {
        // Clear invalid data
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
      }
    }

    // Auto-fill email if remember me was checked
    const rememberMe = localStorage.getItem('rememberMe');
    const savedEmail = localStorage.getItem('savedEmail');
    
    if (rememberMe === 'true' && savedEmail) {
      // This would be handled by the LoginForm component
      console.log('Auto-filling saved email:', savedEmail);
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Background Component */}
      <LoginBackground />
      
      {/* Main Content */}
<div className="relative z-10 min-h-screen flex items-center justify-center px-4 py-8 sm:py-12">
<div className="w-full max-w-md sm:max-w-lg md:max-w-xl">
          {/* Login Card */}
          <div className="bg-card border border-border rounded-2xl shadow-elevation-3 p-8">
            {/* Header Component */}
            <LoginHeader />
            
            {/* Login Form Component */}
            <LoginForm />
            
            {/* Subscription Status Component */}
            <SubscriptionStatus />
          </div>
          
          {/* Footer */}
          <div className="mt-8 text-center">
            <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
              <span>© {new Date().getFullYear()} NijanandTextile</span>
              <span>•</span>
              <button className="hover:text-foreground transition-smooth">
                Privacy Policy
              </button>
              <span>•</span>
              <button className="hover:text-foreground transition-smooth">
                Terms of Service
              </button>
            </div>
            <div className="mt-2 text-xs text-muted-foreground">
              Version 2.1.0 • Built for textile manufacturing excellence
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;